// Builds an ECharts scatter series that plots grow-photo thumbnails on a time chart.
//
// Each point sits at the photo's capture time (COALESCE(taken_at, created_at)) so a
// photo without an explicit taken_at anchors at its upload time rather than the epoch.
// The symbol is the presigned thumbnail URL (image://...). Clicking a point opens the
// photo (handled by an ECharts 'click' listener that reads data.photoId).
//
// Points are plotted against a SECOND, hidden yAxis fixed to [0,1] (yAxisIndex 1), so
// thumbnails pin to a constant band near the top of the plot regardless of how the
// metric's own yAxis auto-scales. Callers add that hidden axis (see MetricChart).
//
// Returns null when there are no usable photos, so callers can spread
// `...(series ? [series] : [])` into extraSeries.

const THUMB_SIZE = 28;   // px symbol size on the chart
const THUMB_Y = 0.86;    // position within the hidden [0,1] axis — clears grid.top so the
                          // full thumbnail renders instead of being clipped at the plot edge

export function photoScatterSeries(photos = [], { darkMode = false } = {}) {
  const points = photos
    .filter((p) => p.thumbnail_url)
    .map((p) => {
      const t = p.taken_at || p.created_at;
      if (!t) return null;
      return {
        value: [new Date(t).getTime(), THUMB_Y],
        symbol: `image://${p.thumbnail_url}`,
        photoId: p.id,
      };
    })
    .filter(Boolean);

  if (points.length === 0) return null;

  return {
    name: "Photos",
    type: "scatter",
    yAxisIndex: 1, // the hidden [0,1] axis MetricChart adds when photoSeries is present
    symbolSize: THUMB_SIZE,
    data: points,
    // ECharts image:// symbols ignore itemStyle.border*, so separation from the plot
    // lines behind them comes from a shadow (which image symbols do render) instead.
    itemStyle: {
      shadowColor: darkMode ? "rgba(0,0,0,0.6)" : "rgba(0,0,0,0.35)",
      shadowBlur: 4,
    },
    z: 5,
    tooltip: { show: false },
    silent: false,
  };
}
